/** As the other icons. */
const SIZE = 16;

/** A stop sign with an X (Tabler has none): an octagon, the X cut out of it (what's behind shows through). */
export function StopXFilled({ class: cls, size = SIZE }: { class?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      class={`shrink-0 ${cls ?? ""}`}
    >
      <path
        fill-rule="evenodd"
        d="M8.3 2h7.4a1 1 0 0 1 .7.3l5.3 5.3a1 1 0 0 1 .3.7v7.4a1 1 0 0 1-.3.7l-5.3 5.3a1 1 0 0 1-.7.3H8.3a1 1 0 0 1-.7-.3l-5.3-5.3a1 1 0 0 1-.3-.7V8.3a1 1 0 0 1 .3-.7l5.3-5.3a1 1 0 0 1 .7-.3Zm1.4 6.3a1 1 0 0 0-1.4 1.4L10.6 12l-2.3 2.3a1 1 0 1 0 1.4 1.4l2.3-2.3 2.3 2.3a1 1 0 0 0 1.4-1.4L13.4 12l2.3-2.3a1 1 0 0 0-1.4-1.4L12 10.6Z"
      />
    </svg>
  );
}
